/**
 * Unified SLA escalation thresholds.
 *
 * Single source of truth — imported by DockCard, DockDrawer, ShiftStatusStrip,
 * useTimeElapsed defaults, and any other component that determines dwell urgency.
 *
 * Rules:
 *   < SLA_WARN_MINUTES        → Normal (cyan / success)
 *   >= SLA_WARN_MINUTES & <= SLA_CRITICAL_MINUTES → OVER SLA (amber / warning)
 *   >  SLA_CRITICAL_MINUTES   → CRITICAL (red + pulse / error)
 */
export const SLA_WARN_MINUTES = 60;
export const SLA_CRITICAL_MINUTES = 120;

/** Returns a severity label for the given elapsed minutes. */
export function dwellSeverity(elapsedMinutes: number): 'normal' | 'warning' | 'critical' {
    if (elapsedMinutes > SLA_CRITICAL_MINUTES) return 'critical';
    if (elapsedMinutes >= SLA_WARN_MINUTES) return 'warning';
    return 'normal';
}
